import { MemberTypes } from '../../models/ss-api/responses/login.response';
import { GlobalService } from '../../services/global.service';
import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { WindowService } from '../../services/window-dialogs/window.service';
import { WindowTypes, WindowActionTypes } from '../../services/window-dialogs/window.event';
import { WindowSettings } from '../../services/window-dialogs/window.settings';
import { ssApiService } from '../../services/ss-api.service';
import { LiveHubService } from '../../services/livehub.service';
import { GetLiveHubConnectionsRequest } from '../../models/ss-api/requests/get.livehub.connections.request';
import { DuplicateEmailTemplateRequest } from '../../models/ss-api/requests/duplicate.email.template.request';
import { RemoveAdminAccessRequest } from '../../models/ss-api/requests/remove.admin.access.request';
import { AdminHubRegistryRequest } from '../../models/ss-api/requests/admin.hub.registry.request';
import { LicenseEditTransferDetailsRequest } from '../../models/ss-api/requests/license.edit.transfer.details.request';
import { AdminHubListRequest } from '../../models/ss-api/requests/admin.hub.list.request';
import { HoldStatsRequest } from '../../models/ss-api/requests/hold.stats.request';
import { HoldStatusesArray, HoldStatuses } from '../../models/ss-api/responses/hold.statistics.item';
import { GlobalActivitiesRequest } from '../../models/ss-api/requests/global.activities.request';
import { GlobalAdminBrowseLogsRequest } from '../../models/ss-api/requests/global.admin.browse.logs.request';
import { UpdateMemberUsageLogRequest } from '@models/ss-api/requests/update.member.usage.log.request';
import { GetBenchmarksRequest } from '@models/ss-api/requests/get.benchmarks.request';
import { UpdateVideoCardBenchmarkRequest } from '@models/ss-api/requests/update.video.card.benchmark.request';
import { UpdateCPUBenchmarkRequest } from '@models/ss-api/requests/update.cpu.benchmark.request';
import { AddVideoCardBenchmarkRequest } from '@models/ss-api/requests/add.video.card.benchmark.request';
import { AddCPUBenchmarkRequest } from '@models/ss-api/requests/add.cpu.benchmark.request';
import { AddVersionHardwareRequirementRequest } from '@models/ss-api/requests/add.version.hardware.requirement.request';
import { UpdateVersionHardwareRequirementRequest } from '@models/ss-api/requests/update.version.hardware.requirement.request';
import { AddVersionWithPathRequest } from '@models/ss-api/requests/add.version.with.path.request';
import { UpdateVersionWithPathRequest } from '@models/ss-api/requests/update.version.with.path.request';


@Component({
    selector: 'app-globals',
    templateUrl: './globals.component.html',
    styleUrls: ['./globals.component.css']
})
export class GlobalsComponent implements OnInit {


    windowID: string = "0";
    windowType: string = "";
    eventType: string = "";
    eventDateTime: string = "";
    excludedKeys: string[] = [];

    StartDate: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    EndDate: Date = new Date();

    NewEventDateTime: Date = new Date(new Date().getFullYear(), new Date().getMonth(), 21, 8, 20);
    
    TrainingClassName : String = "some name";
    

    constructor( private liveHub: LiveHubService, private dialogService: DialogService, public gb: GlobalService, private windowService: WindowService, private API: ssApiService, private updaterLive: LiveHubService) {

        windowService.onEvent.subscribe(event => {
            this.windowID = event.ID;
            this.windowType = WindowTypes[event.WindowType];
            this.eventType = WindowActionTypes[event.ActionType];
            this.eventDateTime = new Date().toTimeString();

            console.log("event received", event);
        })


    }




    ngOnInit() {
    }

    MemberTypeToString(type: MemberTypes): string {
        return MemberTypes[type];
    }



    showDialog() {


        var licenseID = 1;
        var windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        var result = this.windowService.OpenWindow<string>(WindowTypes.Email, "B3BA5-3KDD7-KB49C", windowSettings);

        let subscription = result.onEvent.subscribe(event => {
            console.log("event received. My id:" + result.ID + ", event id:" + event.ID, event);

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe;

        });
    }


    test0(this: Document, ev: Event) {

        console.log("readystate event", this)
        console.log("readystate event", ev);
    }

    test(this: Window, ev: Event) {

        console.log("docment state", this.document);

        console.log("unload event", this)
        console.log("unload event", ev);
        alert('window is closed');
    }



    test1(this: Window, ev: Event) {
        console.log("change event", this)
        console.log("change event", ev);
    }

    EditTransferDetails(){
        var request = new LicenseEditTransferDetailsRequest();
        request.ID = 29068; //The license's ID
        request.TransferLimitMax = 59;
        request.TransferLimitInTimeMinutes = null; //For most fields, null means "no change"
        request.Note = "I'm adding a note really just to test the functionality"; //If you specify a note, one will be created.  Empty string means no note
        request.TransferDisabled = true;
        request.TransferDisabledReason = "Prevent possible TOS";
        request.TransferLimitPCs = 4; //null or < 1 convert to 4 - we can't zero this out
        
        var sub = this.API.EditTransferDetails(request).subscribe(result => {

            sub.unsubscribe();

            console.log("EditTransferDetails", result);
        }); 
    } 
    
    GetHoldStatistics(){
        var request = new HoldStatsRequest();
        request.StartDate = new Date('2019-09-15T00:00:00' );
        request.EndDate = null;

        var includedStatuses = new HoldStatusesArray();
        /*
        includedStatuses.push(HoldStatuses.HoldFinished);
        includedStatuses.push(HoldStatuses.HoldFinishedCancelled);
        includedStatuses.push(HoldStatuses.HoldFinishedDeclined);
        includedStatuses.push(HoldStatuses.LicenseResumed);
        */
        includedStatuses.push(HoldStatuses.Active);

        request.HoldStatuses = includedStatuses;
        
        var sub = this.API.GetHoldStatistics(request).subscribe(result => {

            sub.unsubscribe();

            console.log("GetHoldStatistics", result);
        }); 
    } 
    
    GetAdmins(){
        var sub = this.API.getAdmins().subscribe(result => {

            sub.unsubscribe();

            console.log("getAdmins", result);
        }); 
    } 

    GISUpdateMemberUsageLog(){
        var request = new UpdateMemberUsageLogRequest();
        request.UsageLogID = 50027; //The primary key of the record
        request.ParcelBoxInches = 4000; //Nullable - null indicates no change
        request.FullSizeImage = false; //Nullable - null indicates no change
        request.DownloadImageParameters = "";
        request.OverwriteSearchAddress = "";

        var sub = this.API.GISUpdateMemberUsageLog(request).subscribe(result => {

            sub.unsubscribe();

            console.log("GISUpdateMemberUsageLog", result);
        });      
    }
    
    GetAllNotesForFamily(){
        var sub = this.API.getAllNotesForFamily(21264).subscribe(result => {

            sub.unsubscribe();

            console.log("getAllNotesForFamily", result);
        }); 
    } 

    GetGlobalActivities(){
    var request = new GlobalActivitiesRequest();
    request.StartDate = new Date('2019-09-14T00:00:00' );
    request.EndDate = new Date('2019-10-13T23:59:59' );
    
    var sub = this.API.GetGlobalActivities(request).subscribe(result => {

            sub.unsubscribe();

            console.log("GetGlobalActivities ==", result);
        }); 
    } 

    GlobalAdminBrowseLogs(){
    var request = new GlobalAdminBrowseLogsRequest();
    request.StartDate = new Date('2019-09-14T00:00:00' );
    request.EndDate = new Date('2019-10-13T23:59:59' );
    request.AdminID = 18; //null means All admins
    
    var sub = this.API.GlobalAdminBrowseLogs(request).subscribe(result => {
        
            sub.unsubscribe();

            console.log("GlobalAdminBrowseLogs ==", result);
        }); 
    } 

     ForceDataCacheRefresh(){
        this.liveHub.InvokeConnection('ForceDataCacheRefresh');
    }

    NotifySpecificMemberOfNewVersion(){
        this.liveHub.InvokeConnection('NotifySpecificMemberOfNewVersion', '89AK2-EDFA9-KE4E9');
    }
    
    NotifyUpdateVersionForceGroupMembersOfNewVersion(){
        this.liveHub.InvokeConnection('NotifyUpdateVersionForceGroupMembersOfNewVersion', 4);
    }

    PollReg(){
        console.log("PollReg");

        var request = new GetLiveHubConnectionsRequest();
        request.ActiveConnectionsOnly = true;
        
        var sub2 = this.API.GetLiveHubConnections(request).subscribe(result => {
            var counter = 0;
            var totalcounter = 0;
            var connections = result.Data;
            connections.forEach(async connection => {
                if (connection.LicenseKey != null && connection.LicenseKey.length > 5){
                    if ( counter <= 20 ){
                        setTimeout(() => {
                            let request2: AdminHubRegistryRequest = {
                                LicenseKey: connection.LicenseKey,
                                RootString: 'currentuser',
                                SubKey: '%structure_studios_root%\\SE3D20',
                                Key: 'ProxyServer'
                            };
                            this.liveHub.InvokeConnection('GetLicenseRegistryValue', request2);
                            //console.log("try" + counter)
                        }, counter * 500);
                    }
                    counter = counter + 1;    
                }
                totalcounter = totalcounter + 1;
            //console.log(connection.ConnectionID);
            });
            console.log("totalcounter", totalcounter);
            console.log("counter", counter);
            sub2.unsubscribe();
        }); 


        console.log("PoolReg");
	}
	
    PollWMI(){
        console.log("PollWMI");

        var request = new GetLiveHubConnectionsRequest();
        request.ActiveConnectionsOnly = true;
        
        var sub2 = this.API.GetLiveHubConnections(request).subscribe(result => {
            var counter = 0;
            var totalcounter = 0;
            var connections = result.Data;
            connections.forEach(async connection => {
                if (connection.LicenseKey != null && connection.LicenseKey.length > 5){
                    if ( counter <= 20 ){
                        setTimeout(() => {
                            let request2: AdminHubListRequest = {
                                LicenseKey: connection.LicenseKey,
                                Command: "select AdapterRAM from Win32_VideoController",
                                Method: "WMI Query",
                                MaxResults: 1,
                                Offset: 0
                            };
                            this.liveHub.InvokeConnection('BrowseLicenseWMI', request2);
                            //console.log("try" + counter)
                        }, counter * 500);
                    }
                    counter = counter + 1;    
                }
                totalcounter = totalcounter + 1;
            //console.log(connection.ConnectionID);
            });
            console.log("totalcounter", totalcounter);
            console.log("counter", counter);
            sub2.unsubscribe();
        }); 


        console.log("PoolWMI");
    }
    
	DuplicateEmailTemplate(){
        var request = new DuplicateEmailTemplateRequest();
        request.EmailTemplateID = 205;
        
        var sub2 = this.API.DuplicateEmailTemplate(request).subscribe(result => {

            sub2.unsubscribe();

            console.log("DuplicateEmailTemplate=>", result);
        }); 

	}

	GetBenchmarks(){
        var request = new GetBenchmarksRequest();
        request.IncludeCPUs = true;
        request.IncludeVideoCards = true;
        request.MissingValuesOnly = false;
        
        var sub = this.API.GetBenchmarks(request).subscribe(result => {

            sub.unsubscribe();

            console.log("GetBenchmarks=>", result);
        }); 

    }
    
    UpdateVideoCardBenchmark(){
        var request = new UpdateVideoCardBenchmarkRequest();
        request.VideoCardBenchmarkID = 426;
        request.NewBenchmarkScore = 22222;
        
        var sub = this.API.UpdateVideoCardBenchmark(request).subscribe(result => {

            sub.unsubscribe();

            console.log("UpdateVideoCardBenchmark=>", result);
        }); 

	} 
    
    UpdateCPUBenchmark(){
        var request = new UpdateCPUBenchmarkRequest();
        request.CPUBenchmarkID = 200;
        request.NewBenchmarkScore = 8888;
        
        var sub = this.API.UpdateCPUBenchmark(request).subscribe(result => {

            sub.unsubscribe();

            console.log("UpdateCPUBenchmark=>", result);
        }); 

    } 
     
    AddVideoCardBenchmark(){
        var request = new AddVideoCardBenchmarkRequest();
        request.VideoCardName = "Something New that does not exist";
        request.BenchmarkScore = 22222;
        
        var sub = this.API.AddVideoCardBenchmark(request).subscribe(result => {

            sub.unsubscribe();

            console.log("AddVideoCardBenchmark=>", result);
        }); 

	} 
    
    AddCPUBenchmark(){
        var request = new AddCPUBenchmarkRequest();
        request.CPUName = "Brand new";
        request.BenchmarkScore = 8888;
        
        var sub = this.API.AddCPUBenchmark(request).subscribe(result => {

            sub.unsubscribe();

            console.log("AddCPUBenchmark=>", result);
        }); 

    } 
    
    AddVersionHardwareRequirement(){
        var request = new AddVersionHardwareRequirementRequest();
        
        request.HardwareCheckID = 6;
        request.VersionItemID = 44;

        request.MinimumValue = 100;
        request.RecommendedValue = 200;
        request.OptimalValue = 300;

        request.MinimumValueLabel = "One Hundred";
        request.RecommendedValueLabel = "Two Hundred";
        request.OptimalValueLabel = "300";

        request.ScoreWeighting = 30; // 30% of the overall grade for the version
        
        var sub = this.API.AddVersionHardwareRequirement(request).subscribe(result => {

            sub.unsubscribe();

            console.log("AddVersionHardwareRequirement=>", result);
        }); 

    } 

    UpdateVersionHardwareRequirement(){
        var request = new UpdateVersionHardwareRequirementRequest();
        
        request.VersionHardwareRequirementID = 8;
        request.HardwareCheckID = 6; //Specify, even if we didn't change

        request.MinimumValue = 200;
        request.RecommendedValue = 400;
        request.OptimalValue = 600;

        request.MinimumValueLabel = "Two Hundred";
        request.RecommendedValueLabel = "Four Hundred";
        request.OptimalValueLabel = "600";

        request.ScoreWeighting = 34; // 34% of the overall grade for the version
        
        var sub = this.API.UpdateVersionHardwareRequirement(request).subscribe(result => {

            sub.unsubscribe();

            console.log("UpdateVersionHardwareRequirement=>", result);
        }); 

    } 

    DeleteVersionHardwareRequirement(){
        var versionHardwareRequirementID = 8;

        var subscription = this.API.DeleteVersionHardwareRequirement(versionHardwareRequirementID).subscribe(result => {

            subscription.unsubscribe();

            console.log("DeleteVersionHardwareRequirement", result);
        });            
    }    

	GetPostponeGroups(){

        var subscription = this.API.GetPostponeGroups().subscribe(result => {

            subscription.unsubscribe();

            console.log("GetPostponeGroups", result);
        });            
    }  

	GetActiveVersions(){

        var subscription = this.API.GetActiveVersions().subscribe(result => {

            subscription.unsubscribe();

            console.log("GetActiveVersions", result);
        });            
    }  

    AddVersionWithPath(){
        var request = new AddVersionWithPathRequest();
        
        request.Description = "2602";
        request.FilePath = "G:\\updater test builds\\v2602.zip";
        request.IsMinorUpdate = false;
        request.Name = "2602";
        request.Postponable = false; //Typically only 3.0 so far
        request.VersionNumber = "2602"; //No decimals

        //New properties
        request.MinimumLiveHubVersion = 0; //We don't require a min - yet!
        request.MinimumScoreThreshold = 40; //Can determine version to version
        request.RecommendedScoreThreshold = 80;
        request.PostponeGroupID = null; //Null since this isn't postponable
        
        var sub = this.API.AddVersionWithPath(request).subscribe(result => {

            sub.unsubscribe();

            console.log("AddVersionWithPath=>", result);
        }); 

    }  

    UpdateVersionWithPath(){
        var request = new UpdateVersionWithPathRequest();
        
        request.Description = "2602";
        request.FilePath = "G:\\updater test builds\\v2602.zip";
        request.IsMinorUpdate = false;
        request.Name = "2602";
        request.Postponable = true; //Let's make it postponable just for fun
        request.VersionNumber = "2602"; //No decimals

        //New properties
        request.MinimumLiveHubVersion = 0; //We don't require a min - yet!
        request.MinimumScoreThreshold = 40; //Can determine version to version
        request.RecommendedScoreThreshold = 80;
        request.PostponeGroupID = 2; //1 is standard, 2 is debug.  You get these from GetPostponeGroups() endpoint
        
        var sub = this.API.UpdateVersionWithPath(request).subscribe(result => {

            sub.unsubscribe();

            console.log("UpdateVersionWithPath=>", result);
        }); 

    }  

	GetHardwareChecks(){

        var subscription = this.API.GetHardwareChecks().subscribe(result => {

            subscription.unsubscribe();

            console.log("GetHardwareChecks", result);
        });            
    }  



	GetLicensePCs(){
        var licenseID = 27907;

        var subscription = this.API.GetLicensePCs(licenseID).subscribe(result => {

            subscription.unsubscribe();

            console.log("GetLicensePCs", result);
        });            
    }  
      
    MakeLicensePCInactive(){
        var licensePCID = 2;

        var subscription = this.API.MakeLicensePCInactive(licensePCID).subscribe(result => {

            subscription.unsubscribe();

            console.log("MakeLicensePCInactive", result);
        });            
    }   
      
    MakeLicensePCUnavailable(){
        var licensePCID = 2;

        var subscription = this.API.MakeLicensePCUnavailable(licensePCID).subscribe(result => {

            subscription.unsubscribe();

            console.log("MakeLicensePCUnavailable", result);
        });            
    }   
      
    MakeLicensePCAvailable(){
        var licensePCID = 2;

        var subscription = this.API.MakeLicensePCAvailable(licensePCID).subscribe(result => {

            subscription.unsubscribe();

            console.log("MakeLicensePCAvailable", result);
        });            
    }   

    DeleteLicensePC(){
        var licensePCID = 2;

        var subscription = this.API.DeleteLicensePC(licensePCID).subscribe(result => {

            subscription.unsubscribe();

            console.log("DeleteLicensePC", result);
        });            
    }   

	RemoveAdminAccess(){

        var request = new RemoveAdminAccessRequest();
        request.AdminID = 26;

        var subscription = this.API.RemoveAdminAccess(request).subscribe(result => {

            subscription.unsubscribe();

            console.log("RemoveAdminAccess result = ", result);
        });            
    }  

}